import { Check } from 'lucide-react';

const STEPS = [
  { n: 1, label: 'Parties & Property', short: 'Parties' },
  { n: 2, label: 'Rent & Deposit', short: 'Rent' },
  { n: 3, label: 'Additional Terms', short: 'Terms' },
  { n: 4, label: 'Custom Clauses', short: 'Clauses' },
  { n: 5, label: 'Review & Generate', short: 'Review' },
];

export const StepIndicator = ({ currentStep, onStepClick, allowDirectNavigation = false }) => (
  <div className="flex items-start mb-5">
    {STEPS.map(({ n, label, short }, idx) => {
      const done = n < currentStep;
      const active = n === currentStep;
      return (
        <div key={n} className="flex items-center flex-1 last:flex-none">
          <button
            type="button"
            className="flex flex-col items-center group min-w-0"
            onClick={() => (done || allowDirectNavigation) && onStepClick(n)}
            disabled={!done && !allowDirectNavigation}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold border-2 transition-colors shrink-0
                ${active ? 'bg-[#1e3a5f] border-[#1e3a5f] text-white' : ''}
                ${done ? 'bg-[#1e3a5f] border-[#1e3a5f] text-white cursor-pointer' : ''}
                ${!active && !done ? `bg-white border-gray-300 ${allowDirectNavigation ? 'text-gray-700 cursor-pointer' : 'text-gray-400'}` : ''}
              `}
            >
              {done ? <Check className="h-4 w-4" /> : n}
            </div>
            <span
              className={`mt-1 text-center leading-tight
                block sm:hidden text-[10px] max-w-[48px]
                ${active ? 'text-[#1e3a5f] font-semibold' : done || allowDirectNavigation ? 'text-[#1e3a5f]' : 'text-gray-400'}
              `}
            >
              {short}
            </span>
            <span
              className={`mt-1 text-xs hidden sm:block text-center leading-tight max-w-[80px]
                ${active ? 'text-[#1e3a5f] font-semibold' : done || allowDirectNavigation ? 'text-[#1e3a5f]' : 'text-gray-400'}
              `}
            >
              {label}
            </span>
          </button>
          {idx < STEPS.length - 1 && (
            <div
              className={`flex-1 h-0.5 mx-1 sm:mx-2 mt-[-16px] sm:mt-[-20px] ${n < currentStep ? 'bg-[#1e3a5f]' : 'bg-gray-200'}`}
            />
          )}
        </div>
      );
    })}
  </div>
);
